/**
 * The build this bundle was made from (round 8.1, task 1).
 *
 * Her iPhone runs the app off its Home Screen icon, and a new bundle can sit
 * waiting behind the scenes (registered but not yet taken — see
 * src/ui/appUpdate.ts for when it is) with nothing on screen saying which
 * build she is actually running. `APP_BUILD` is the first half of making
 * that visible: a short git SHA (`'dev'` outside a checkout — a CI archive
 * with `.git` stripped, or `vite dev`), read from `__APP_BUILD__` — a
 * `define` vite.config.ts resolves once at build time, declared in
 * src/build.d.ts.
 *
 * One exported constant rather than each caller reading the global directly,
 * so `http-transport.ts` and `DeviceScreen.tsx` can import it like anything
 * else and a test can too.
 */
export const APP_BUILD: string = __APP_BUILD__;
